import { cn } from "@/lib/utils";

interface NumberBoxProps {
  value: number | string;
  onChange?: (value: string) => void;
  /** View-only: sunk style, not editable. */
  readOnly?: boolean;
  /** Accessible name. */
  label: string;
  /** Unit after the number, e.g. "%". */
  suffix?: string;
  min?: number;
  max?: number;
  /** Box width in px (default 64). */
  width?: number;
}

/** Mono boxed numeric input; `readOnly` renders the view-only style. */
export function NumberBox({ value, onChange, readOnly = false, label, suffix, min, max, width = 64 }: NumberBoxProps) {
  return (
    <span
      data-readonly={readOnly ? "true" : "false"}
      style={{ width }}
      className={cn(
        "mx-0.5 inline-flex h-[30px] items-center justify-center gap-0.5 rounded-lg border border-ds-line2 px-1.5 align-middle font-ds-mono text-[13.5px] font-semibold",
        "focus-within:ring-2 focus-within:ring-ds-accent",
        readOnly ? "bg-ds-sunk text-ds-ink2" : "bg-ds-panel text-ds-ink"
      )}
    >
      <input
        type="number"
        aria-label={label}
        value={value}
        min={min}
        max={max}
        readOnly={readOnly}
        onChange={(event) => onChange?.(event.target.value)}
        className="w-full min-w-0 appearance-none bg-transparent text-center outline-none [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
      />
      {suffix && <span className="flex-none text-ds-ink3">{suffix}</span>}
    </span>
  );
}
